import Blue from '~/core';

new Blue({
  name: 'Composition Background',
  selector: '.composition__background-image--static',
  setup(composition) {
    let timeout;
    const setHeight = () => {
      clearTimeout(timeout);
      composition.style.height = '';
      timeout = setTimeout(() => {
        composition.style.height = composition.offsetHeight + 'px';
      }, 200);
    };

    setHeight();
    window.addEventListener('resize', setHeight);
  },
});
